import { FC, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { KeyResultI } from '~src/store/okrs/keyResultStream/interfaces';
import ProgressBar from '~src/shared/ProgressBar';
import { formatKeyresultProgressable } from '~src/modules/okrs/manageObjectives/shared/utils';
import { translateContent } from '~src/services/translationServices';

const BelowLine = styled.div`
  display: flex;
  justify-content: space-between;
`;

const UpdateInfo = styled.span.attrs({ className: 'caption_text' })`
  color: ${({ theme }) => theme.baseBlue.a6};
`;

const UpperLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

interface Props {
  keyResult: KeyResultI;
}

const KeyResultProgress: FC<Props> = ({ keyResult }) => {
  const [t] = useTranslation();
  const themeContext = useContext(ThemeContext);

  const progressColor = { 29: themeContext.gold.a10, 69: themeContext.green.a10 };

  // be careful the progress means how much is between min and max not starting with 0.
  // so if min=2 and max=4 and progress is 3 (3/4) its 50% not 75% what would be assumed
  const relativeProgress = Math.round(
    ((keyResult.progress - keyResult.min) / (keyResult.max - keyResult.min)) * 100,
  );
  const { name, updated_at, progress, max } = keyResult;
  return (
    <>
      <UpperLine>
        <div>{translateContent(name)}</div>
        <UpdateInfo>
          {t('x.okr.key_result_item.last_updated.text')} {moment(updated_at).format('L')}
        </UpdateInfo>
      </UpperLine>
      <BelowLine>
        <div>{formatKeyresultProgressable(progress)}</div>
        <div>
          {formatKeyresultProgressable(progress)} / {formatKeyresultProgressable(max)}
        </div>
      </BelowLine>
      <ProgressBar
        height={5}
        width="100%"
        staticProgress
        progress={relativeProgress}
        progressColor={progressColor}
      />
    </>
  );
};

export default KeyResultProgress;
